export default {
      id: "presence-offline-usage",
      viewBox: "0 0 10 10",
      url: "/dist/svg/" + "sprite.svg#presence-offline-usage",
      toString: function () {
        return this.url;
      }
    }